    <div
        bsModal
        #createOreEditLookups="bs-modal"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="createOreEditLookups"
        aria-hidden="true"
    >
        <div
            class="modal-dialog right-modal"
            [ngClass]="active ? 'slide-right-in' : 'slide-right-out'"
            role="document"
        >
            <form class="h-100" *ngIf="active" #appEntityForm="ngForm" novalidate (ngSubmit)="save(appEntityForm)" autocomplete="off">

                <div class="modal-content">
                    <div class="modal-content-wrapper">
                        <div class="modal-header" style="display: block;background-color: #ffffff !important;">
                            <h4 class="modal-title text-left" style="display: block;">
                                <span *ngIf="appEntity?.id" class="font-weight-bold">{{l("Edit")}} {{entityObjectType.name}}</span>
                                <span *ngIf="!appEntity?.id" class="font-weight-bold">{{l("CreateNew")}} {{entityObjectType.name}}</span>
                            </h4>
                            <p>* {{l("PleaseFillTheBelowInformation")}}</p>

                            <button style="position: absolute;right: 8px;top: 8px;" type="button" class="close" (click)="close()"
                            aria-label="Close" [disabled]="saving">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body text-left">

                            <div class="form-group">
                                <label for="AppEntity_Code">
                                    <span class="required">* </span>
                                    {{l("Code")}}
                                    <span class="text-danger ml-3" *ngIf="showCodeErrMsg">{{ 'CodeIsRequired' | localize }}</span>
                                </label>
                                <app-codes *ngIf="!appEntity?.id"
                                    [objectType]="entityObjectType.code"
                                    [code]="appEntity.code"
                                    [editMode]=false
                                    placeHolder="Add your code"
                                    (getCodeValue)="getCodeValue($event)" 
                                    [maxlength]="6">
                                </app-codes>
                                <app-codes *ngIf="appEntity?.id"
                                    [objectType]="entityObjectType.code"
                                    [editMode]=true
                                    [code]="appEntity.code"
                                    (getCodeValue)="getCodeValue($event)"
                                    [maxlength]="6" >
                                </app-codes>

                            </div>

                            <!-- <div class="form-group">
                                    <label for="AppEntity_Code">{{l("Code")}} <span class="required">* </span></label>
                                    <input type="text" id="AppEntity_Code" class="form-control form-control-sm aria-input-text" [(ngModel)]="appEntity.code" name="Code"     required/>
                                </div> -->

                                <div class="form-group">
                                    <span class="required">* </span>  <label for="AppEntity_Name">{{l("Name")}} </label>
                                    <input type="text" id="AppEntity_Name" class="form-control form-control-sm aria-input-text" [(ngModel)]="appEntity.name" name="Name"     required/>
                                </div>
                                 <div class="form-group d-flex" *ngIf="!appEntity?.id || appEntity.nonlookup">
                                    <input [disabled]="!enableAddToLookup" type="checkbox" id="AppEntity_AddToLookup" class="form-control form-control-sm  col-1 mr-3" [(ngModel)]="addToLookup" name="addToLookup"/>
                                    <label for="AppEntity_AddToLookup" class="pt-2">{{l("Add to lookup")}} </label>
                                </div>

                              

                                <div class="row col-12">
                                    <div class="mr-3">
                                        <input
                                            type="radio"
                                            id="solid"
                                            name="visualType"
                                            class="form-control"
                                            [checked]="
                                            visual.solid
                                            "
                                            [value]="true"
                                            class="mr-2 radio"
                                           (change)="setSolid(true)"
                                        />
                                        <label for="online">{{"Solid" | localize}}</label>
                                    </div>

                                    <div>
                                        <input
                                            type="radio"
                                            id="image"
                                            name="visualType"
                                            [value]="false"
                                            class="form-control"
                                            [checked]="visual.image"
                                            class="mr-2 radio"
                                            (change)="setSolid(false)"
                                        />
                                        <label for="inperson">{{"Image"| localize}}</label>
                                    </div>
                                </div>

                                <div class="d-flex flex-column" *ngIf="extraAttributes?.length">
                                  <div class="row"> <span class="required pl-2 pr-1">* </span><label for="AppEntity_Code">{{l("Extra Attributes")}}</label></div> 
                                    <div class="row justify-content-center mt-4">
                                        <div class="col-12 mb-4"  *ngFor="let extraAttr of extraAttributes">
                                            <div >
                                                <div *ngIf="isSize && !isHost">
                                                    <label>{{extraAttr.name | localize}}</label>
                                                </div>
                                                <div class="d-flex align-items-center">

                                                    <div class="wide-drop-down d-flex flex-grow-1 " *ngIf="extraAttr?.lookupData && extraAttr?.acceptMultipleValues">
                                                        <div class="flex-grow-1 mr-1">
                                                            <p-multiSelect
                                                                [options]="extraAttr.lookupData"
                                                                [styleClass]="'w-100 custom-dropdown'"
                                                                [(ngModel)]="extraAttr.selectedValues"
                                                                name="extraAttr_{{extraAttr.name}}"
                                                                [placeholder]="l('Select') + ' ' + extraAttr.name"
                                                                (onChange)="multiValuesExtraAttributeOnChange($event,extraAttr)">
                                                            </p-multiSelect>
                                                        </div>
                                                    </div>

                                                    <div class="wide-drop-down flex-grow-1 " *ngIf="extraAttr?.lookupData && !extraAttr?.acceptMultipleValues">
                                                        <div *ngIf="!isSize">
                                                            <p-dropdown
                                                            [options]="extraAttr.lookupData"
                                                            [styleClass]="'w-100 custom-dropdown'"
                                                            [(ngModel)]="extraAttr.selectedValues"
                                                            name="extraAttr_{{extraAttr.name}}"
                                                            [placeholder]="l('Select') + ' ' + extraAttr.name"
                                                            (onChange)="singleValueExtraAttributeOnChange($event,extraAttr)">
                                                            </p-dropdown>
                                                        </div>
                                                        <div *ngIf="isSize && !isHost">
                                                            <p-dropdown
                                                            [options]="sizes"
                                                            [styleClass]="'w-100 custom-dropdown'"
                                                            [(ngModel)]="extraAttr.selectedValues"
                                                            name="extraAttr_{{extraAttr.name}}"
                                                            [placeholder]="l('Select') + ' ' + extraAttr.name"
                                                            (onChange)="singleValueExtraAttributeOnChange($event,extraAttr)">
                                                            </p-dropdown>
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="flex-grow-1" *ngIf="extraAttr.dataType === 'boolean' || extraAttr.dataType === 'bit' ">
                                                        <div class="radio-inline mt-2">
                                                            <label class="pr-2">
                                                                {{extraAttr.name}}
                                                            </label>
                                                            <label class="radio radio-accent radio-primary mr-4" for="extraAttr{{extraAttr.name}}_1" >
                                                                <input type="radio" (click)="notLookupExtraAttributeOnChange('true',extraAttr)"
                                                                name="extraAttr_{{extraAttr.name}}" id="extraAttr{{extraAttr.name}}_1" [value]="'true'" [(ngModel)]="extraAttr.selectedValues"/>
                                                                {{l("Yes")}}
                                                            </label>
                                                            <label class="radio radio-accent radio-primary" for="extraAttr{{extraAttr.name}}_0" >
                                                                <input type="radio" (click)="notLookupExtraAttributeOnChange('false',extraAttr)" name="extraAttr_{{extraAttr.name}}" id="extraAttr{{extraAttr.name}}_0" [value]="'false'" [(ngModel)]="extraAttr.selectedValues">
                                                                {{l("No")}}
                                                            </label>
                                                            <a *ngIf="extraAttr.selectedValues" class="ml-5 text-underline text-black-50" (click)="resetExtraAttributeSelectedValue(extraAttr)"> Reset</a>
                                                        </div>
                                                    </div>
                                                    <div class="flex-grow-1" *ngIf="extraAttr.dataType === 'Datetime' ">
                                                        <label>
                                                            {{extraAttr.name}}
                                                        </label>
                                                        <input type="text" (keyup)="notLookupExtraAttributeOnChange($event.target.value,extraAttr)" name="{{extraAttr.name}}" autocomplete="off" placeholder="{{extraAttr.name}}" class="form-control" bsDatepicker id="extraAttr{{extraAttr.name}}" [(ngModel)]="extraAttr.selectedValues">
                                                    </div>
                                                    <div class="flex-grow-1" *ngIf="extraAttr.dataType === 'Numeric' ">
                                                        <label>
                                                            {{extraAttr.name}}
                                                        </label>
                                                        <input type="number" (keyup)="notLookupExtraAttributeOnChange($event.target.value,extraAttr)" name="{{extraAttr.name}}" placeholder="{{extraAttr.name}}" class="form-control" id="extraAttr{{extraAttr.name}}" [(ngModel)]="extraAttr.selectedValues">
                                                    </div>
                                                    <div class="flex-grow-1" *ngIf="extraAttr.dataType === 'string' && !extraAttr.isLookup && visual.solid">
                                                        <div class="row d-flex align-items-baseline justify-content-start ">
                                                            <label>
                                                                {{extraAttr.name}}
                                                            </label>
                                                          <input type="text" (keyup)="notLookupExtraAttributeOnChange($event.target.value,extraAttr)"
                                                          name="{{extraAttr.name}}" placeholder="{{extraAttr.name}}" class="form-control"  id="extraAttr{{extraAttr.name}}"
                                                           [(ngModel)]="extraAttr.selectedValues">
                                                         <div class="border rounded" class="w-25 " *ngIf="extraAttr.dataType === 'string' && !extraAttr.isLookup  " >
                                                          <input (colorPickerChange)="onColorChange($event, extraAttr)"
                                                          *ngIf="extraAttr.name === 'Color HEXA Code' || extraAttr.name === 'Color HEX Code'"
                                                            class="picker" [(colorPicker)]="extraAttr.selectedValues"
                                                           [style.background]="extraAttr.selectedValues || '#09c' "/>
                                                         </div>
                                                        </div>
                                                      </div>


                                                      <div class="flex-grow-1" *ngIf="extraAttr.validEntries && extraAttr.dataType === 'dropDownList'">
                                                        <div class="row d-flex align-items-baseline justify-content-start ">
                                                            <label class="pr-2">
                                                                {{extraAttr.name}}
                                                            </label>
                                                            <p-dropdown
                                                            [options]="dropdownOptions(extraAttr.validEntries)"
                                                            [styleClass]="'w-100 custom-dropdown'"
                                                            [(ngModel)]="extraAttr.selectedValues"
                                                            name="extraAttr_{{extraAttr.name}}"
                                                            [placeholder]="l('Select') + ' ' + extraAttr.name"
                                                            (onChange)="notLookupExtraAttributeOnChange($event.value,extraAttr)">
                                                            </p-dropdown>
                                                        
                                                         </div>
                                                        </div>

                                                    <!-- <p class="ml-2" *ngIf="extraAttr.isLookup && !extraAttr?.lookupData?.length">{{ "NoData" | localize }} ...</p> -->
                                                    <!-- <div *ngIf="!isSize || !isColor">
                                                        <a class="border rounded text-primary add-new-lookup-btn ml-3" *ngIf="extraAttr.isLookup && extraAttr.allowAddNew" (click)="openCreateAppEntityListModal(extraAttr)">
                                                            <i  class="fas fa-pen"></i>
                                                        </a>
                                                    </div> -->
                                                    <div *ngIf="isColor && isHost">
                                                        <a class="border rounded text-primary add-new-lookup-btn ml-3" *ngIf="extraAttr.isLookup && extraAttr.allowAddNew" (click)="openCreateAppEntityListModal(extraAttr)">
                                                            <i  class="fas fa-pen"></i>
                                                        </a>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                           
                            <div class="row align-items-baseline mb-5 item-photos m-3 p-3" *ngIf="visual.image" 
                            [ngStyle]="{
                                'border': attachmentsSrcs  && attachmentsSrcs?.length >0  && attachmentsSrcs[0]!='' ? 'none': '2px solid #EEEEEEEE' 
                            }"
                             style=" border-radius: 12px;">
                                <div class="col-12 item-photos-header pt-4 pb-2"  style="    background-color: white !important;">
                                    <div class="d-flex flex-wrap justify-content-between">
                                          <!--  <h6>
                                                {{ 'EntityPhotos' | localize}}
                                            </h6>-->
                                        

                                        <div style="display: flex; align-items: center;" *ngIf="! (attachmentsSrcs  && attachmentsSrcs?.length >0 && attachmentsSrcs[0]!='' )">
                                            <img src="../../../assets/placeholders/Group 15.png" style="margin-right: 15px;" />
                                            <div style="    line-height: 0.5;" class="pt-3">
                                                <p style="font-weight: bold; color: black;">
                                                    {{ 'Upload files' | localize }}
                                                </p>
                                                <p>
                                                    {{ 'Select and upload the files' | localize }}
                                                </p>
                                            </div>
                                        </div>
                                        <div>
                                         <!--
                                            <input type="text" (change)="changeFn($event)" id="AspectRatio" [placeholder]="l('AspectRatio')" class="form-control form-control-sm" [(ngModel)]="aspectRatio" name="aspectRatio" />
                                            <br/>
                                            
                                            <select *ngIf="attCategoriesShow==true" class="form-control col-12" #ref (change)="getSelectedValue(ref.value)" >
                                            
                                                <option *ngFor="let attCat of attCategories let i=index" value={{i}}    [selected]="attCat.sycAttachmentCategory.code===productImageCategory.sycAttachmentCategory.code" >{{ attCat?.sycAttachmentCategory?.name }}</option>

                                            </select>-->
                                        </div> 
                                        <!-- <div>
                                            <button (click)="removeAllAttachments()" type="button" class="bg-white btn btn-hover-primary p-1 text-center" [disabled]="attachmentsSrcs.length == 1">
                                                <i class="flaticon-delete m-0 p-0"></i>
                                            </button>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="col-12 item-photos-body" 
                                [ngStyle]="{
                                    'border': attachmentsSrcs  &&attachmentsSrcs?.length >0 && attachmentsSrcs[0]!=''  ? 'none': '2px dashed #EEEEEE' 
                                }"
                                style="    background-color: white !important;border-radius: 12px;">
                                    <div class="row">
                                        <div class="image-wrapper" [ngClass]="{'upload':!attachment}" *ngFor="let attachment of attachmentsSrcs; index as i">
                                            <label *ngIf="!attachment" class="d-flex flex-column justify-content-center h-100 align-items-center" for="file_{{i}}">
                                                <div class="align-items-end d-flex justify-content-center  upload-image-icons ml-5 mb-3 mt-3">
                                                   <!--  <div class="left-icon">
                                                        <i class="fa-photo-video fas " ></i> 
                                                    </div>-->
                                                    <div class="middle-icon">
                                                        <i class="fas " > <img src="../../../assets/placeholders/cloud-add.png" /> </i>
                                                    </div>
                                                  <!--  <div class="right-icon">
                                                         <i class="fas fa-file-video "></i> 
                                                    </div>-->
                                                </div>
                                                <div class="text-center pl-5 ml-5">
                                                    <p  style="font-weight: bold; color: black;
    white-space: nowrap;">
                                                    Choose a file or drag & drop it here
                                                    <p >
                                                    <p >
                                                        <!-- {{ 'YouCanSendUpTo25MBInAttachments' | localize}}. -->

                                                        {{ 'File an be JPEG, PNG, PDf, and MP4 formats, up to 25 MB' | localize}}.   
                                                    </p>
                                                    <p style="color: #F6851D !important;">*Image Aspect-Ratio is 16:9 </p>

                                                    <a class="btn btn-primary btn-sm mb-3 upload-btn" style="color: white !important; background-color: #4A0D4A !important;">
                                                        <!-- {{ 'AddAttachedFile' | localize}} -->
                                                        {{ 'Browse File' | localize}}
                                                    </a>
                                                </div>
                                                <input type="file" id="file_{{i}}" class="fileImage" #file (change)="fileChange($event,productImageCategory,i,aspectRatio,true)">
                                            </label>
                                            <a  *ngIf="attachment" class="d-flex flex-column justify-content-center h-100 align-items-center kt-avatar" >
                                                <div class="d-flex flex-column justify-content-center h-100 w-100 position-absolute view-img-overlay">
                                                    <div class="text-center mb-3">
                                                        <i class="fa-photo-video fas bg-transparent text-white fa-3x" ></i>
                                                    </div>
                                                    <div class="text-center">
                                                        <button type="button" class="btn btn-dark text-white border-lg border-white" (click)="openImageViewer(attachment)">
                                                            {{ 'ImagePreview' | localize}}
                                                        </button>
                                                    </div>
                                                    <div class="bg-white kt-avatar__upload" for="file" (click)="removePhoto(i)" >
                                                        <i class="fa fa-times text-danger"></i>
                                                    </div>
                                                </div>
                                                <!-- <img *ngIf="!appItem.entityAttachments && !appItem.entityAttachments.length" src="../../../../../assets/img/Untitled.png"/> -->
                                                <img *ngIf="attachment" [src]="attachment"/>

                                            </a>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="form-group d-flex">
                                <input  type="checkbox" id="AppEntity_IsDefault" class="form-control form-control-sm  col-1 mr-3" [(ngModel)]="appEntity.isDefault" name="isDefault"/>
                                <label for="AppEntity_IsDefault" class="pt-2">{{l("Set default value")}} </label>
                            </div>

                            <div class="form-group" *ngIf="addToLookup">
                                <label for="AppEntity_Notes">{{l("Notes")}}</label>
                                <input style="height: 131px !important;" type="text" id="AppEntity_Notes" class="form-control form-control-sm aria-input-text" [(ngModel)]="appEntity.notes" name="Notes"    />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button [disabled]="saving" type="button" class="btn btn-default btn-gray" (click)="close()" style="border-radius: 5px;
                            background-color: white !important;
                            border: white !important;color: #4A0D4A !important;">{{l("Cancel")}}</button>
                            <button type="submit" class="btn btn-primary blue  btn-blue btn-save" style="border-radius: 5px;
                            background-color: #4A0D4A !important;
                            border: #4A0D4A !important;color: white;"  [disabled]="!appEntityForm.form.valid || uploader.isUploading" [buttonBusy]="saving" [busyText]="l('SavingWithThreeDot')"> <span>{{l("Save")}}</span></button>
                        </div>

                    </div>
                </div>
            </form>

        </div>
    </div>


<confirm-modal-side *ngIf="displaySaveSideBar" [content1]="'Successfully saved' | localize" [content2]="'The '+ entityObjectType.code +' you created is successfully saved You can create another one Or Back to the Lookups list.'"
[buttonNo]="'No thanks' | localize" [defualtButton]="true" [buttonYes]="('Create another' | localize) +' '+ entityObjectType.name" [type]="'displaySaveSideBar'" [icon]="''" [displayItem]="displaySaveSideBar"
(buttonClicked)="askForAnotherAdd($event)"></confirm-modal-side>
